enum Plans {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  LIFETIME = 'LIFETIME',
  TRIAL = 'TRIAL',
}

export { Plans };
